export enum EPaymentDate {
    firststofMonth = 1,
    sixteenthofMonth = 2,
    Other = 3
}
